package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.HorizontalScrollBehavior
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum

@Composable
fun <T> TopTabItems(
    windowSizeMode: WindowSizeModeEnum,
    selectedTab: T,
    onTabClick: (T) -> Unit,
    tabItems: List<T>,
    fillMaxWidth:Boolean=false,
) where T : Enum<T>, T : TitleEnum {
    Column(
        modifier = Modifier
            .margin(topBottom = Dimen.largePadding)
            .fillMaxWidth()
    ) {
        Row(
            modifier = HorizontalScrollBehavior
                .toModifier()
                .overflow(Overflow.Auto)
                .fillMaxWidth()
                .weight(1f)
                .thenIf(
                    fillMaxWidth,
                    HorizontalScrollBehavior.toModifier().fillMaxWidth()
                )

            ,
            verticalAlignment = Alignment.CenterVertically
        ) {
            tabItems.forEach { tab ->
                TabItem(
                    windowSizeMode = windowSizeMode,
                    title = tab.title,
                    isSelected = tab == selectedTab,
                    onTabClick = {
                        onTabClick(tab)
                    },
                )
            }
        }

        Separator()

    }
}
